// React
import { useEffect, useRef } from 'react';

// Animation
import { animate, inView } from 'framer-motion';

// Utils
import cn from '@/utils/cn';

// Styles
import styles from '../Animations.module.css';

const config = {
  type: 'spring' as const,
  duration: 0.8,
};

interface RevealScaleIn {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  offsetBeforeDisplay?: number;
}

function RevealScaleIn({ children, className = '', delay = 0, offsetBeforeDisplay = 0.5 }: RevealScaleIn) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      inView(
        ref.current,
        (element) => {
          animate(
            element,
            {
              opacity: 1,
              transform: ['scale(0)', 'scale(1)'],
            },
            {
              ...config,
              bounce: 0.3,
              delay: delay + 0.3,
            },
          );
        },
        {
          amount: offsetBeforeDisplay,
        },
      );
    }
  }, []);

  return (
    <div className={cn([styles.scalein, className])} ref={ref}>
      {children}
    </div>
  );
}

export default RevealScaleIn;
